<template>
    <div>
        <el-form :inline="true" :model="searchForm"  class="forTbFilter">
            <el-form-item label="套餐类型："> 
                <el-select v-model="searchForm.simType" clearable>
                    <el-option value="0" label="独立套餐"></el-option>
                    <el-option value="1" label="流量共享"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="卡状态：" width="80"> 
                <el-select v-model="searchForm.state" clearable>
                    <el-option value="1" label="沉默期" ></el-option>
                    <el-option value="2" label="正常" ></el-option>
                    <el-option value="3" label="停机"></el-option>
                    <el-option value="4" label="测试期"></el-option>
                    <el-option value="44" label="过期"></el-option>
                    <el-option value="55" label="注销"></el-option>
                    <el-option value="20" label="其他"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属代理商：">
                <el-select v-model="searchForm.agentId" filterable placeholder="请选择或输入关键字" clearable>
                    <el-option v-for="item in agentsOption" :value="item.agentId" :key="item.agentId" :label="item.agentName"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="流量池：">
                <el-select v-model="searchForm.simPoolId" filterable placeholder="请选择或输入关键字" clearable>
                    <el-option v-for="item in flowPoolOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="ICCID：">
                <el-input v-model.trim="searchForm.iccid" clearable></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo" clearable></el-input>
            </el-form-item>
            <el-form-item label="设备号：">
                <el-input v-model.trim="searchForm.sn" clearable></el-input>
            </el-form-item>

            <el-form-item label="运营商名称："> 
                <el-select v-model="searchForm.supplierId" clearable>
                    <el-option v-for="item in supplierOption" :value="item.id" :key="item.id" :label="item.supplierName"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="套餐流量："> 
                <el-select v-model="searchForm.totalFlow" clearable>
                    <el-option value="2" label="2M"></el-option>
                    <el-option value="5" label="5M"></el-option>
                    <el-option value="10" label="10M"></el-option>
                    <el-option value="30" label="30M"></el-option>
                    <el-option value="50" label="50M"></el-option>
                    <el-option value="100" label="100M"></el-option>
                    <el-option value="300" label="300M"></el-option>
                    <el-option value="500" label="500M"></el-option>
                    <el-option value="700" label="700M"></el-option>
                    <el-option value="1024" label="1G"></el-option>
                </el-select>
            </el-form-item>
            <span class='span-defined'>
                <label class='label-defined'>阈值预警：</label>
                <el-input-number v-model.trim="searchForm.dataLevel"  :min="0" :max="100" ></el-input-number>
                <label class='label-defined percent-label'>%</label>
            </span>

            <el-form-item label="排序规则："> 
                <el-select v-model="searchForm.orderBy" clearable>
                    <el-option value="expire_time  DESC" label="到期时间"></el-option>
                    <el-option value="use_flow DESC" label="已使用流量"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary"  @click="getAdminCardListHandler">搜索查询</el-button>
                <el-button type="success"  @click="exportAdminSimInfoHandle()">导出Excel</el-button>
                <el-button type="primary"  @click="updateDowntime()">一键更新停机</el-button>
            </el-form-item>
        </el-form>
        <el-table  
        :data="tbpg.tableData"
        :default-sort = "{prop: 'activationrTime', order: 'descending'}"
         border max-height="610" >
            <el-table-column label="ICCID" width="180px">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号" width="130px"></el-table-column>
            <el-table-column label="IMSI" width="130px">
                <template v-slot="scope">
                   {{scope.row.imsi=='init_imsi'? '': scope.row.imsi}}
                </template>  
            </el-table-column>
            <el-table-column prop="sn" label="设备号" width="130px"></el-table-column>
            <el-table-column prop="simPoolName" label="流量池"></el-table-column>
            <el-table-column prop="agentPathName" label="所属代理商" show-overflow-tooltip></el-table-column>
            <el-table-column prop="supplierName" label="运营商"  show-overflow-tooltip></el-table-column>
            <el-table-column prop="activationrTime" label="激活时间" width="100" sortable :formatter="formatActivationrTime">
            </el-table-column>
            <el-table-column prop="expireTime" label="到期时间" width="100" sortable :formatter="formatExpireTime">
            </el-table-column>
            <el-table-column label="总流量" width="70">
				<template v-slot="scope">
				   {{scope.row.totalFlow}}
				</template>  
			</el-table-column>
            <el-table-column prop="useFlow" label="已使用流量" width="90"></el-table-column>
            <el-table-column label="剩余流量" width="80">
				<template v-slot="scope">
				   {{scope.row.remainsFlow}}
				</template>  
			</el-table-column>
            <el-table-column label="总语音" width="70">
				<template v-slot="scope">
				   {{scope.row.totalVoice}}
				</template>  
			</el-table-column>
            <el-table-column prop="useVoice" label="已使用语音" width="90"></el-table-column>
            <el-table-column label="剩余语音" width="80">
				<template v-slot="scope">
				   {{scope.row.remainVoice}}
				</template>  
			</el-table-column>
            <el-table-column prop="stateName" label="卡状态"  width="70"></el-table-column>
            <el-table-column prop="simTypeName" label="卡类型"  width="60">
                <template v-slot="scope">
                   {{scope.row.cardCategory==null? '' : scope.row.cardCategory}}
                </template>  
            </el-table-column>
            <el-table-column prop="simTypeName" label="套餐类型"  width="80"></el-table-column>
            <el-table-column prop="remark" label="备注"  width="100" show-overflow-tooltip></el-table-column>
            
            <el-table-column label="操作" width="60" >
                <template v-slot="scope">
                    <el-button type="text" size="small" @click="showConfirmToRemoveDialog(scope.row)">删除</el-button>
                </template>    
            </el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 

        <el-dialog 
        title="发送短信"
        :visible.sync="sendSMSVisible"
        width="30%"  @close="hideSendSMSDialog" :close-on-click-modal="false">
            <el-form ref="actionFormData" :model="actionFormData" :rules="actionFormDataRules" label-width="120px">
                <el-form-item label="接入号码：" prop="receiveIntoNo">
                    <span> {{actionFormData.receiveIntoNo}}</span>
                </el-form-item>
                <el-form-item label="短信内容：" prop="msg">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2}"
                      placeholder="请输入内容"
                      v-model.trim="actionFormData.msg"
                      maxlength="200"
                      show-word-limit
                      clearable>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button  @click="hideSendSMSDialog">取 消</el-button>
                <el-button type="primary" @click="showConfirmToSendSMSDialog">发 送</el-button>
            </div>   
        </el-dialog> 


        <el-dialog
            title="提示"
            :visible.sync="confirmDialogVisible"
            width="30%">
            <span >确定要删除吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleDeleteCard">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="confirmToSendSMSVisible"
            width="30%">
            <span >确定要发送短信吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmToSendSMSVisible = false">取 消</el-button>
                <el-button type="primary" @click="sendSMSAction">确 定</el-button>
            </span>
        </el-dialog>     
         
    </div>
</template>

<script>
import {getAdminCardList, exportSimInfo, deleteCard,getAdminCardList5} from '@/api/sim.js'
import {sendSMS} from '@/api/sms.js'
import common from '@/utils/common.js'
export default {
    data(){         
        return {
            searchForm: {
                state:'',
                dataLevel: '',
                totalFlow: '',
                sn: null,
                simPoolId: '',
                supplierId: '',
                isVoice:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            flowPoolOption: [],
            supplierOption: [],//运营商名称列表
            agentsOption: [],
            cardStateOption: [],
            simHandleRules: {
                agentId: [{required: true, message: '请选择代理商', trigger: 'change'}]
            },
            actionFormDataRules:{
                msg:[{required: true, message: '请输入短信内容', trigger: 'blur'}]
            },
            sendSMSVisible: false,//发送短信编辑框
            confirmDialogVisible: false,//删除卡片确认框
            confirmToSendSMSVisible: false,  //短信发送确认框
            actionFormData:{//短信发送等动作携带的数据对象
                receiveIntoNo: '',
                msg:'',
            },
            cardId:'',
                
        }
    },
    methods: {
        
        getAdminCardListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            getAdminCardList5(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('detailMenu').click();
        },
        exportAdminSimInfoHandle(){//导出excel文件
            var data = JSON.parse(JSON.stringify(this.searchForm));
            data.token = localStorage.getItem('token');
            data.pageSize = 10000;
            data.prePageNum = 10000;
             common.sysRequest('/excels/admin/voice/all', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success('下载中，请稍后在下载中心查询');
                }else{
                    this.$message.error(res.data.message);
                }
            })  
        },
        updateDowntime(){//一键更新停机
            common.sysRequest('sim/updateStop', {}, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message({message: res.data.message, type: 'success'});
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAdminCardListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAdminCardListHandler();
        },
        showConfirmToRemoveDialog(row){
            this.cardId = row.id;
            this.confirmDialogVisible = true;
        },
        showSendSMSDialog(row){
            this.actionFormData.receiveIntoNo = row.intoNo;
            this.sendSMSVisible = true;
        },
        hideSendSMSDialog(){
            this.sendSMSVisible = false;    
            this.$refs.actionFormData.resetFields();  
        },
        showConfirmToSendSMSDialog(){
            this.$refs.actionFormData.validate(valid => {
                if(valid){
                    this.confirmToSendSMSVisible = true;
                }
            });
        },
        sendSMSAction(){
            let data = {
                receiveIntoNo: this.actionFormData.receiveIntoNo.split("；"),
                msg: this.actionFormData.msg,
            }
            sendSMS(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.getAdminCardListHandler();
                }else{
                    this.$message.error(res.data.message);
                }
                this.actionFormData.receiveIntoNo = '';
                this.actionFormData.msg = '';
                this.sendSMSVisible = false;
                this.confirmToSendSMSVisible = false;
            })
        },
        handleDeleteCard(){
            let param = {id:this.cardId};
            deleteCard(param).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }

                this.confirmDialogVisible = false;
                this.cardId = '';
                this.getAdminCardListHandler();

            });
        },
        formatActivationrTime(row) {
            return row.activationrTime==null ? '' : row.activationrTime.split(' ')[0];
        },    

        formatExpireTime(row) {
            return row.expireTime==null ? '' : row.expireTime.split(' ')[0];
        }, 

        //获取流量池
        getFlowPool(){
            common.sysRequest('simPool/list', {agentId: null}, 'post').then(res => {
                if(res.data.code == 200){
                    for(let key in res.data.data){
                        this.flowPoolOption.push({id: key, name:res.data.data[key]})
                    }
                }else{
                    this.$message.error(res.data.message);
                }             
            })   
        }

    },
    created () {
        this.searchForm.state = this.$store.state.menu.cardState;
        this.searchForm.dataLevel = this.$store.state.menu.cardDataLevel;
        this.getAdminCardListHandler();
        common.getSupplierOptsCom(this, 'supplierOption');
        common.sysRequest('/agent/listOption', {}, 'post').then(res => {
            if(res.data.code == 200){
                this.agentsOption = res.data.data;
            }

        });

        this.getFlowPool();
    },

    computed: {
        searchDatefromDataSummary() {
            return {
                cardState:this.$store.state.menu.cardState,
                dataLevel:this.$store.state.menu.cardDataLevel
            }

        },

        
    },

    watch:{
        searchDatefromDataSummary(data){
            this.searchForm.state = data.cardState;
            this.searchForm.dataLevel = data.dataLevel;
            this.getAdminCardListHandler();
            common.getSupplierOptsCom(this, 'supplierOption');
        }
    }
}
</script>

<style lang="scss" scoped>
    .span-defined{
        width: 284px;
        display: inline-block;
        position: relative;
        margin-left: 30px;
    }
    .label-defined{
        display: inline-block;
        height: 32px;
        line-height:32px;
        font-size: 14px;
        color: #606266;
    }
    .percent-label{
        height: 28px;
        line-height: 28px;
        background: #fff;
        z-index: 100;
        position: absolute;
        right: 120px;
        top: 2px;
        font-size: 16px;
    }

    
</style>

